import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApplicationService } from '../../../services/application.service';
import { LookupService } from '../../../services/lookup.service';
import { club } from '../../../models/club';
import { saveDrillRequest } from '../../../models/saveDrillRequest';
import { AuthenticationService } from '../../../services/authentication.service';
import { TemplateService } from '../../../services/template.service';

@Component({
  selector: 'app-create-drill',
  standalone: true,
  imports: [FormsModule, NgFor],
  templateUrl: './create-drill.component.html',
  styleUrl: './create-drill.component.css'
})
export class CreateDrillComponent implements OnInit {
  constructor(private applicationService:ApplicationService, private lookupService:LookupService, private authenticationService:AuthenticationService, private templateService:TemplateService) {}

  @Output() saved = new EventEmitter();
  clubs:club[] = [];
  drill:saveDrillRequest = {
    label: '',
    description: '',
    club_id: null,
    username: '',
    is_deleted: false,
    id:null
  };

  ngOnInit(): void {
    let username = this.authenticationService.loggedInUser?.username;
    if(!username) return;
    this.drill.username = username;
    this.getClubs();
  }

  async saveDrillClicked() {
    this.applicationService.showGlobalSpinner();
    await this.templateService.saveDrill(this.drill);
    this.saved.emit();
    this.applicationService.hideGlobalSpinner();
  }

  async getClubs() {
    this.clubs = await this.lookupService.searchClubs();
  }
}
